import { useContext } from "react";
import { DiscountContext } from "../contexts/discountContext/discountContext";

export const useDiscount = () => {
  const context = useContext(DiscountContext);
  if (!context) throw new Error("useDiscount must be used within DiscountProvider");
  return context;
};